import React, {useState, useContext, useEffect} from "react";
import Accordion from "../../components/accordion/Accordion";
import {cleanDrops} from "../../hooks/helpers";
import ImgEncabezado from "../../components/imagenEncabezado/ImgEncabezado";
import FacilitatorsIns from "./FacilitatorsIns";
import EditAcademy from "./components/EditAcademy";
import {AcademyContext} from "../../context/AcademyProvider";
import {LoadComponet} from "../../components/loaders/Loader";

export default function DomecAcademyView({theme}) {
   const [status, setStatus] = useState([0, 0, 0, 0, 0]);
   const {getList, isLoading} = useContext(AcademyContext);

   const changeMode = (newVal, key) => {
      let nStatus = cleanDrops(status.length, key, newVal);
      // console.log(nStatus);
      setStatus([...nStatus]);
   };

   useEffect(() => {
      getList();
   }, []);

   return (
      <>
         {isLoading.list ? (
            <LoadComponet isVisible={true} />
         ) : (
            <>
               <ImgEncabezado
                  title="Portada para Domecq Academy"
                  theme={theme}
                  status={status[0]}
                  changeMode={(val) => changeMode(val, 0)}
                  titleDesc="Domecq Academy"
                  idUpdate={5}
                  nameUpdate="Academy"
                  video={true}
                  linkWeb="domecq_academy"
               />
               <Accordion
                  title="bienvenida domecq academy"
                  theme={theme}
                  status={status[1]}
                  changeMode={(val) => changeMode(val, 1)}
                  titleDesc="Texto de Bienvenida Domecq Academy"
                  video={true}
               >
                  <EditAcademy
                     idUpdate={1}
                     type={1}
                     nameUpdate="Bienvenida"
                     video={true}
                     viewTitle="domecqAcademy"
                     title="Texto para bienveniad Domecq"
                     hashUrl="#bienvenida"
                  />
               </Accordion>
               <Accordion
                  title="programas de formación "
                  theme={theme}
                  status={status[2]}
                  changeMode={(val) => changeMode(val, 2)}
                  titleDesc="Texto nuestros Programas de Formación"
                  video={false}
               >
                  <EditAcademy
                     idUpdate={2}
                     type={2}
                     nameUpdate="Programas de Formación"
                     video={false}
                     viewTitle="domecqAcademy"
                     title="Programas de formación"
                     hashUrl="#formacion"
                  />
               </Accordion>
               <Accordion title="Facilitadores" theme={theme} status={status[3]} changeMode={(val) => changeMode(val, 3)}>
                  <EditAcademy
                     idUpdate={3}
                     type={3}
                     nameUpdate="Facilitadores"
                     video={false}
                     viewTitle="domecqAcademy"
                     title="Texto para facilitadores"
                  />
               </Accordion>
               <Accordion title="Instalaciones" theme={theme} status={status[4]} changeMode={(val) => changeMode(val, 4)}>
                  <EditAcademy
                     idUpdate={4}
                     type={4}
                     nameUpdate="Instalaciones"
                     video={false}
                     viewTitle="domecqAcademy"
                     title="Texto para instalaciones"
                  />
               </Accordion>
            </>
         )}
      </>
   );
}
